import React from 'react';
import { Field, FieldsWrapper, Header } from '../index.styles';
import concatAddress from 'utils/concat-address';
import {TUsersDetail} from "../../../../../../../types/entities/users";

type TViewProfileInfo = {
  data: any;
  userData?: TUsersDetail
};

const ViewPersonalInfo = ({ data, userData }: TViewProfileInfo) => {
  return (
    <>
      <Header>
        <h4>{'ID Details'}</h4>
      </Header>

      <FieldsWrapper>
        {
          data ? (
            <>
              <Field>
                <span className="title">{'KTP Number'}:</span>
                <span className="value">{data.idNumber || '—'}</span>
              </Field>
              <Field>
                <span className="title">{'Address'}:</span>
                <span className="value">{ concatAddress(data.idAddress) || '—' }</span>
              </Field>
            </>
          ) : (
            <>
              <Field>
                <span className="title">{'KTP Number'}:</span>
                <span className="value">{userData?.ekyc.ktpNumber || '—'}</span>
              </Field>
            </>
          )
        }
      </FieldsWrapper>
    </>
  );
};

export default ViewPersonalInfo;
